import * as _ from 'lodash';
import * as moment from 'moment';

import { Component, SimpleChanges, OnInit, OnChanges, Input } from '@angular/core';
import { Sector, Booking, Addon, Totals } from '../../../../models/booking.model';

@Component({
    selector: 'gaweb-open-addons-wrapper',
    templateUrl: './open-addons-wrapper.component.html'
})

export class OpenAddonsWrapperComponent implements OnInit, OnChanges {
    @Input() booking: Booking;
    @Input() openAddons: Array<Addon>;

    processing: boolean;
    firstRequest: boolean;
    showOpenAddons: boolean;
    summarisedAddons: Array<any> = [];

    constructor(
    ) {
        this.processing = false;
    }

    ngOnInit(): void {
        if (this.booking) {
            this.onBookingBeingSet();
        }
        this.showOpenAddons = false;
        if(this.openAddons.length > 0){
            this.summariseAddons();
            this.showOpenAddons = true;
        }
    }

    summariseAddons() {
        this.openAddons.forEach(a => {
            a.AddonOptions.forEach(o => {
                const summed = this.summarisedAddons.filter(x => x.Title == a.Title);
                if(!!summed){
                } else {
                    this.summarisedAddons.push(_.cloneDeep(a));
                }
            })
        })
    }

    onShowOpenAddons = (expanded: boolean) => {
        if (this.firstRequest) {
            this.firstRequest = false;
            return;
        }
        this.showOpenAddons = expanded;
    }

    onBookingBeingSet = () => {

    }

    ngOnChanges(changesObj: SimpleChanges): void {
    }

}


// WEBPACK FOOTER //
// ./src/app/shared/components/itinerary/travel-dates/open-addons-wrapper/open-addons-wrapper.component.ts